 
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SmLogHistoryState } from '../../actions/types/schedule-maintenance/SmLogHistoryTypes';

/**
 * Initial Dashboard state in store
 */
const initialState: SmLogHistoryState = {
  isLoading: true,
  isTrackerLoading: true,
  iseventDetailsLoading: true,
  success: false,
  errorMessage: '',
  SmLogHistoryDetails: [{
    actionType: '',
    createdBy: '',
    createdTimeStamp: '',
    endTimestamp: '',
    impactedServices: [],
    isDropped: false,
    maintenanceName: '',
    maintenanceStatus: '',
    message: '',
    serviceType: '',
    startTimestamp: '',
    status: '',
    updatedBy: '',
    updatedTimeStamp: '',
    usersEmail: [],
    uuid: '',
    version: 0,
    impactedServicesList: []
  }]
};

/**
 * get metric summary Slice to get metric
 */
export const getSmLogHistorySlice = createSlice({
  name: 'getMetricsSummary',
  initialState,
  reducers: {
    getSmLogHistoryStarted: (state) => {
      state.isLoading = true;
    },

    getSmLogHistorySuccess: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.success = true;
      state.errorMessage = '';
      state.SmLogHistoryDetails = action.payload;
    },

    getSmLogHistoryFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = action.payload;
      state.SmLogHistoryDetails = initialState.SmLogHistoryDetails;
    },

    clearSmLogHistory: (state) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = '';
      state.SmLogHistoryDetails = initialState.SmLogHistoryDetails;
    }
  }
});

export const {
  getSmLogHistoryStarted,
  getSmLogHistorySuccess,
  getSmLogHistoryFail,
  clearSmLogHistory
} = getSmLogHistorySlice.actions;
export default getSmLogHistorySlice.reducer;
